import { fdpz } from '@/api/index'

export function getFDPZ_DetailListPage (data) {
  return fdpz.request({
    method: 'post',
    url: '/getFDPZ_DetailListPage',
    data
  })
}

export function Getinonevehicleflag (data) {
  return fdpz.request({
    method: 'post',
    url: '/Getinonevehicleflag',
    data
  })
}

export function fdpzZCZF (data) {
  return fdpz.request({
    method: 'post',
    url: '/fdpzZCZF',
    data
  })
}

export function getFDPZ_insure (data) {
  return fdpz.request({
    method: 'post',
    url: '/getFDPZ_insure',
    data
  })
}

export function wlh_insure (data) {
  return fdpz.request({
    method: 'post',
    url: '/wlh_insure',
    data
  })
}

export function selectInsurerAddr (data) {
  return fdpz.request({
    method: 'post',
    url: '/selectInsurerAddr',
    data
  })
}
